import SpriteSymbol from "../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-down",
  "use": "icon-caret-down-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-caret-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M694.272 937.216L1218.816 97.92A64 64 0 0 0 1164.544 0H115.456a64 64 0 0 0-54.272 97.92l524.544 839.296a64 64 0 0 0 108.544 0z\" p-id=\"2150\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol